<template>

  <t-page>

    <CymacoQuoteWordServiceRunDialog :path="path" :item="wordServiceRunItem" :primary-key="wordServiceRunPrimaryKey"
                                     @onSubmit="sendQueueWordReport(path,wordServiceRunPrimaryKey,'Orçamento: '+form.quoteCodeLabel)"/>

    <TypeBudgetRejectionReasonDialog :no-option-add="noOptionAdd" @onSubmit="onTypeBudgetRejectionReasonDialog"/>


    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #header>
        <t-msg v-if="codSuccess > 0" info auto-hide>{{ returnMessage }}</t-msg>
      </template>

      <template #title-buttons>

        <t-button @click="openDialogWordServiceRun(form,form.quoteId)"
                  v-show="(command !== 'delete') && getRenderRule('enableWordReport')">
          <b-icon-file-word class="mr-1"></b-icon-file-word>
          Gerar em Word
        </t-button>

        <t-button @click="confirmReverse()"
                  outline-danger
                  v-show="(command === 'delete' || command === 'view') && form.finishedDate !== ''"
                  :sending="reverseFinish"
                  enable-loader
                  :title="!relationAccessSubValidation('sub-quote-reverse-finish') ? 'Perfil de acesso não habilitado para estorno de finalização' : ''"
                  :disabled="!relationAccessSubValidation('sub-quote-reverse-finish')">
          <b-icon-clipboard-x class="mr-1"></b-icon-clipboard-x>
          Estornar finalização
        </t-button>

      </template>

      <template #default="{status}">

        <t-input v-model="form[fieldKey]" hidden/>

        <t-form-tab title="Dados Básicos" @onClick="getTotals()">

          <t-form-card title="Geral">

            <b-row>

              <b-col cols="8">

                <label>Status do Orçamento *</label>

                <b-radio-group class="mb-3" v-model="form.quoteStatusId">

                  <b-radio v-for="typeQuoteStatus in typeQuoteStatusList" :key="typeQuoteStatus.quoteStatusId"
                           :style="{'color':typeQuoteStatus.color !== undefined && typeQuoteStatus.color !== '' ? typeQuoteStatus.color : ''}"
                           :value="typeQuoteStatus.quoteStatusId">
                    {{ typeQuoteStatus.name }}
                  </b-radio>

                </b-radio-group>

              </b-col>


              <t-input v-model="form.issueDate" required cols="2" date date-now label="Data de Emissão"/>

              <t-input v-model="form.validity" cols="2" date help="Até quando este orçamento será válido"
                       label="Data Validade"/>


            </b-row>

            <b-row>

              <t-input v-model="form.quoteCodeLabel"
                       v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                       :add-error="error.quoteCodeLabel" upper cols="2"
                       label="Cód. Orçamento"
                       help="Código inserido manualmente conforme configurado em Clientes > Configurações > Parâmetros"
                       required/>

              <t-input v-model="form.quoteCodeLabel"
                       v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                       :add-error="error.quoteCodeLabel" upper cols="2"
                       fixed
                       label="Cód. Orçamento"
                       help="Código inserido automaticamente conforme configurado em Clientes > Configurações > Parâmetros"
              />


              <b-col cols="6">
                <t-input-person customer :status="status" fixed :command="command" :add-error="error.customerId"
                                v-model="form.customerId"/>

              </b-col>

              <t-input v-model="form.companyId"
                       :options="companyOptions"
                       fixed
                       cols="4"
                       label="Empresa" select/>

            </b-row>


            <b-row>


              <t-input v-model="form.conditionPayment" cols="4" label="Condições de Pagamento" max-length="500"
                       textarea/>

              <t-input v-model="form.conditionDeadline" cols="4" label="Prazo de Entrega" max-length="500"
                       textarea/>

              <t-input v-model="form.sellerId"
                       :options="sellerOptions"
                       cols="4"
                       label="Vendedor" select/>


            </b-row>


            <div class="alert alert-danger" v-if="onRequiredJustifyFinish">

              <b-row>

                <t-input label="Motivo da Reprovação" :required="onRequiredJustifyFinish"
                         :options="typeBudgetRejectionReasonOptions" cols="6"
                         v-model="form.typeBudgetRejectionReasonId" select>


                  <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-type-budget-rejection-reason',search)">Cadastrar Motivo
                      Reprovação
                    </b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar novo Motivo Reprovação"
                              @click="openDialogForm('modal-type-budget-rejection-reason')"
                              icon-plus/>
                  </template>

                </t-input>

                <t-input label="Observação da Reprovação" cols="6" v-model="form.budgetRejectionNote" textarea/>


              </b-row>


            </div>

          </t-form-card>

          <t-form-card title="Inspeção Origem" v-if="pageFormIsLoaded">

            <t-input v-model="form.checklist.enterprise" label="Empreendimento" fixed/>

            <b-row>

              <t-input v-model="form.checklist.enterpriseAddressFull" cols="4" label="Endereço" fixed/>
              <t-input v-model="form.checklist.enterpriseNeighborhood" cols="4" label="Bairro" fixed/>
              <t-input v-model="form.checklist.enterpriseCityFull" cols="4" label="Cidade-UF" fixed/>

            </b-row>

            <b-row>

              <t-input cols="4" v-model="form.checklist.initialDate" label="Data início" datetime fixed/>
              <t-input cols="4" v-model="form.checklist.finalDate" label="Data término" fixed datetime/>

              <t-input cols="4" v-model="form.checklist.checklistNumber" label="Cód. Inspeção" fixed/>

            </b-row>

            <b-button
                :to="{path: '/checklist/'+form.checklist.checklistNumber}"
                class="mt-2"
                variant="outline-primary" target="_blank">
              <b-icon-box-arrow-up-right class="mr-2"/>
              Detalhar Inspeção de Origem
            </b-button>


          </t-form-card>


          <t-form-card title="Valores">

            <b-row>

              <t-input v-model="totals.totalQuote" fixed money decimals="2" highlight cols="3"
                       label="Valor Total"/>

              <t-input v-model="totals.totalOccurrences" fixed money bold decimals="2" cols="3"
                       label="Valor Serviços"/>

              <t-input v-model="totals.totalMaterials" fixed money bold decimals="2" cols="3"
                       label="Valor Materiais" help="Materiais por fora dos serviços utilizado a aba 'Materiais' "/>

              <t-input v-model="totals.totalEquipment" fixed money bold decimals="2" cols="3"
                       label="Valor Equipamentos"
                       help="Equipamentos por fora dos serviços utilizado a aba 'Equipamentos' "/>


            </b-row>


            <b-row>

              <t-input v-model="form.additionalCost" @focusout="getTotals()" money cols="3"
                       label="Custo Adicional (R$)"/>

              <t-input v-model="totals.totalOccurrencePriceCost" fixed money bold decimals="2" cols="3"
                       label="Valor Custos"/>

              <t-input v-model="totals.totalOccurrenceMarkupPercentage" fixed percent bold decimals="2" cols="3"
                       label="Margem Lucro (%)" help="Fórmula (lucro/receita) "/>

              <t-input v-model="totals.totalOccurrencePriceProfit" fixed money bold decimals="2" cols="3"
                       label="Lucro Líquido"/>


            </b-row>


          </t-form-card>

          <t-form-card title="Outros">

            <t-page-form-field-customized
                ref="fieldsGeneral"
                :command="command" :status="status" :user-auth="userAuth"
                :fields-customizable="entityFieldCustomized('page')"
                :primary-key="form.productId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
                :primary-key-column="fieldKey" foreign-key-column="pageId"
            />

            <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

            <b-row v-if="!isInsert() && pageFormIsLoaded">

              <t-input cols="6" v-model="form.logControl.createdUser" label="Usuário Criação" fixed/>
              <t-input cols="6" v-model="form.logControl.createdDate" label="Data Criação" fixed datetime/>

            </b-row>

            <b-row v-if="!isInsert() && pageFormIsLoaded">

              <t-input cols="6" v-model="form.logControl.updatedUser" label="Usuário Modificação" fixed/>
              <t-input cols="6" v-model="form.logControl.updatedDate" label="Data Modificação" fixed datetime/>

            </b-row>

            <!--            <t-input-status v-model="form.status" class="mb-2"/>-->

          </t-form-card>


        </t-form-tab>

      </template>


      <template #out-of-form>

        <t-form-tab title="Serviços" hash="services" lazy>
          <QuoteOccurrence v-if="form.customerId > 0 && form.companyId > 0" :foreign-key="form.quoteId"
                           :totalOccurrences="totals.totalOccurrences"
                           :enterprise-id="form.checklist.enterpriseId"
                           :customerId="form.customerId" :companyId="form.companyId"/>
          <t-msg info v-else>Selecione o cliente e empresa antes de vincular os itens</t-msg>
        </t-form-tab>

        <t-form-tab title="Materiais" hash="material" lazy>
          <QuoteMaterial v-if="form.customerId > 0" :foreign-key="form.quoteId" :customerId="form.customerId"/>
          <t-msg info v-else>Selecione o cliente antes de vincular os materiais</t-msg>
        </t-form-tab>

        <t-form-tab title="Equipamentos" hash="equipment" lazy>
          <QuoteEquipment v-if="form.customerId > 0" :foreign-key="form.quoteId" :customerId="form.customerId"/>
          <t-msg info v-else>Selecione o cliente antes de vincular os equipamentos</t-msg>
        </t-form-tab>

        <!--        <t-form-tab title="Produtos" hash="product" lazy>
                  <QuoteProduct :foreign-key="form.quoteId"/>
                </t-form-tab>-->

        <!--        <t-form-tab title="Fotos" hash="photo" lazy :disabled="!relationAccessPageGeneral('business-quote-file')">

                  <t-msg info>Caso inserir imagens as mesmas serão exibidas na impressão do Orçamento. Para inserir arquivos restritos, utilize a aba arquivos.</t-msg>

                  <QuoteFile :only-view="isView() || isDelete()" type-image
                                  :foreign-key="form[fieldKey]"/>
                </t-form-tab>-->

        <t-form-tab title="Arquivos" hash="file" lazy :disabled="!relationAccessPageGeneral('business-quote-file')">

          <QuoteFile :only-view="isView() || isDelete()"
                     :foreign-key="form[fieldKey]"/>
        </t-form-tab>

        <t-form-tab title="Comentários" hash="comment" :disabled="validationCommentOption === 0" lazy>

          <t-msg info>Comentários internos, não serão exibidos na impressão do Orçamento</t-msg>

          <Comment :foreign-key="currentPage.pageId" :relation-key="form[fieldKey]"
                   disabled-title
                   disabled-category
                   disabled-keyword/>
        </t-form-tab>


      </template>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import http from "@/services/config/http-common";
import QuoteService from "@/services/modules/business/Quote.service";
import QuoteMaterial from "@/views/modules/business/Quote/QuoteMaterial";
import QuoteEquipment from "@/views/modules/business/Quote/QuoteEquipment";
import QuoteOccurrence from "@/views/modules/business/Quote/QuoteOccurrence";
import QuoteFile from "@/views/modules/business/Quote/QuoteFile";
import Comment from "@/views/modules/general/Comment";
import SettingType from "@/model/types/resource/SettingType";
import pageFormEmbeddableMixin from "@/mixins/page/pageFormEmbeddableMixin";
import TypeQuoteStatusService from "@/services/modules/business/TypeQuoteStatus.service";
import StatusFinishType from "@/model/types/resource/StatusOperationType";
import TypeBudgetRejectionReasonDialog from "@/views/modules/business/TypeBudgetRejectionReasonDialog";
import ui from "@/assets/scripts/ui";
import CymacoQuoteWordServiceRunDialog from "@/views/custom/cymaco/CymacoQuoteWordServiceRunDialog.vue";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormEmbeddableMixin],
  name: 'QuoteFormEmbeddable',
  components: {
    CymacoQuoteWordServiceRunDialog,
    QuoteFile, QuoteOccurrence, QuoteMaterial, QuoteEquipment, Comment, TypeBudgetRejectionReasonDialog
  },
  data() {
    return {
      StatusFinishType,
      SettingType,
      path: "business/quote", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "quoteId",
      enableGeneralFields: true,
      /*FORM DECLARADO NO MIXIM PARA VIR DE FORA COM OS CAMPOS PADRÕES JUNTOS COM OS CUSTOMIZADOS*/
      error: {//Campos que podem receber retorno de erro do backend
        originInvoiceCode: "",
        quoteCodeLabel: "",
        customerId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      reverseFinish: false,
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      modeCodeLabel: "",
      typeBudgetRejectionReasonOptions: [],
      companyOptions: [],
      typePaymentOptions: [],
      sellerOptions: [],
      typeQuoteStatusList: [],
      totals: {
        totalProducts: 0,
        totalServices: 0,
        totalMaterials: 0,
        totalOccurrences: 0,
        totalOccurrenceMarkupPercentage: 0,
        totalOccurrencePriceInvoiceTax: 0,
        totalOccurrencePriceCost: 0,
        totalOccurrencePriceProfit: 0,
        totalEquipment: 0,
        totalQuote: 0,
        qtyItems: 0,
        qtyServices: 0,
      },
      validationCommentOption: 0,
      codSuccess: 0,
      returnMessage: "",
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    disableMaterial: Boolean,
    disableEquipment: Boolean,
    disableProduct: Boolean,
    disableOccurrence: Boolean,
  },

  methods: {

    mountedPrepare() {

      this.mountedPrepareEmbeddable()

    },
    async mountedContinued() {

      this.validationCommentOption = this.getRenderRule('validationCommentOption')

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await http.list(this.path + "/selectRelationList").then(async (response) => {

        this.typeBudgetRejectionReasonOptions = response.typeBudgetRejectionReasonOptions
        this.companyOptions = response.companyOptions
        this.paymentPlanOptions = response.typeQuoteStatusOptions
        this.typePaymentOptions = response.typePaymentOptions
        this.sellerOptions = response.sellerOptions

        await this.getTotals()

      }).catch(error => this.responseError(error))

      await TypeQuoteStatusService.getAll().then((list) => {
        this.typeQuoteStatusList = list

        if (this.form.quoteStatusId === 0) {
          this.form.quoteStatusId = this.typeQuoteStatusList[0].quoteStatusId
        }

      }).catch(error => this.responseError(error))

      if (this.objValid(this.form.finishedDate) && this.form.finishedDate !== '' && this.command === 'update') {
        this.command = 'view'
      }

      if (this.objValid(this.form.checklist)) {
        this.form.enterprise = this.form.checklist.enterprise
      }

      this.codSuccess = parseInt(this.$route.query.codSuccess)
      this.returnMessage = this.$route.query.returnMessage

      this.pageFormIsLoaded = true

      await this.mountedContinuedEmbeddable() //Deixar sempre no final

    },
    async onSubmit() {

      //Trava para verificação de regras em objetos Embeddable
      if (this.enabledSubmit) {
        await this.sendingFormDefault()
      } else {
        await this.$emit("beforeSubmit")
      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async getTotals() {

      await QuoteService.getTotalsById(this.form.quoteId).then(
          response => {
            this.totals = response

            //Calcula novamente, pois o custo adicional é gravado somente após enviar ao servidor
            this.totals.totalQuote = this.totals.totalOccurrences + this.totals.totalMaterials + this.totals.totalProducts + this.totals.totalServices + this.totals.totalEquipment + this.form.additionalCost

          }
      )

    },


    onTypeBudgetRejectionReasonDialog(itemInserted) {

      this.form.typeBudgetRejectionReasonId = itemInserted.value
      this.typeBudgetRejectionReasonOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    async confirmReverse() {

      ui.msgConfirm(this, 'ESTORNO DA FINALIZAÇÃO DO ORÇAMENTO', '<span class="text-danger">Tem certeza que deseja realizar o estorno da finalização deste Orçamento <b>' + this.form.quoteCodeLabel + '</b>?', async () => {

        this.reverseFinish = true

        await http.get(this.userAuth.currentPage.path + "/reverse-finish/" + this.form.quoteId).then(async () => {

          await this.goPath(this.userAuth.currentPage.path, {
            codSuccess: 100,
            returnMessage: 'Orçamento ' + this.form.quoteCodeLabel + ' foi estornado com sucesso!'
          })

        }).catch(error => ui.generalResponseError(this, error))

        this.reverseFinish = false

      })

    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },
  computed: {

    onRequiredJustifyFinish() {

      const typeQuoteStatus = this.typeQuoteStatusList.find(a => a.quoteStatusId === this.form.quoteStatusId)
      return typeQuoteStatus && typeQuoteStatus.typeOperation === StatusFinishType.type.STATUS_FINISH_ERROR

    }

  }

}
</script>